var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-menu-container"},[_c('button',{staticClass:"sm-button",on:{"click":_vm.toggleShow}},[_c('img',{attrs:{"src":require("@shared/assets/img/general/menu.svg"),"alt":"menu"}})]),_c('div',{class:[
      _vm.show ? 'active' : '',
      'sm-menu-drop',
    ]},_vm._l((_vm.options),function(option){return _c('button',{key:option.label,class:[
        option.class ? option.class : '',
        'sm-menu-button',
        option.disable ? 'disable' : '',
      ],on:{"click":function($event){return _vm.handleAction(option.action)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }